import cx from 'classnames';
import { Commission } from 'src/models/commission.model';
import { useAppSelector } from 'src/reducers';
import { TimesheetTableCell } from './timesheet-table-cell';
import styles from './timesheet-table.module.scss';

type Props = {
  month: number;
  days: number;
  year: number;
  commission: Commission;
};

const TimesheetTableRow = (props: Props) => {
  const { month, days, year, commission } = props;

  const searchUserTimesheetsReducer = useAppSelector(state => state.searchUserTimesheets);

  const classNames = cx(styles.timesheetCell, styles.totals);
  return (
    <tr key={commission.id} className={styles.timesheetRow}>
      <td className={styles.timesheetCell}>{commission.commissionName}</td>
      {Array.from({ length: days }, (_, index) => (
        <TimesheetTableCell key={index} commission={commission} index={index} year={year} month={month} />
      ))}
      <td className={classNames}>
        {searchUserTimesheetsReducer?.userTimesheets?.statistics?.totalCommission[commission.commissionName] || 0}
      </td>
    </tr>
  );
};

export default TimesheetTableRow;
